module.exports = __webpack_public_path__ + "media/images/sec_3-1-04a555ae9bb16227c7b3cbb4ba73c133.png";